export default __webpack_public_path__ + "static/media/TraceLogo.249f745f.svg";